import { apiRequest } from "../utils";

export const getCatalogProduct = async (productId, token) => {
  return await apiRequest({
    endpoint: `/products/catalog-product/${productId}`,
    method: "GET",
    token,
  });
};

export const getCatalogProductBySlug = async (slug, token) => {
  return await apiRequest({
    endpoint: `/products/catalog-product-by-slug/${slug}`,
    method: "GET",
    token,
  });
};

export const getCatalogProducts = async (token) => {
  const response = await apiRequest({
    endpoint: "/products/catalog-products",
    method: "GET",
    token,
  });

  return response.products;
};
